import * as Sentry from '@sentry/react'

import { STORED_COMPOSITION_LABEL } from 'models/localStorage/constants'

export const getHasLocalStoredComposition = () => {
    try {
        return !!window.localStorage.getItem(STORED_COMPOSITION_LABEL)
    } catch (error) {
        Sentry.captureException(error)
        return false
    }
}
